import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PermissionModel } from 'symbols';

@Injectable()
export class AccessService {
  constructor(private http: HttpClient) {
  }

  getAccess(): Observable<PermissionModel[]> {
    return this.http.get<PermissionModel[]>(`/api/permissions/user-roles/`);
  }
}
